import React, { useState, useEffect, useCallback } from "react";
import { Image } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import UpjLogoAdm from "../../assets/upj-logo.svg";
import "../styles/sideNav.css";

const Sidenav = ({ collapsed, toggleSidebar }) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleResize = useCallback(() => {
    if (window.innerWidth <= 768) {
      setIsMobile(true);
      setIsCollapsed(true);
    } else {
      setIsMobile(false);
      setIsCollapsed(collapsed);
    }
  }, [collapsed]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize(); // Initial check

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  useEffect(() => {
    setIsCollapsed(collapsed);
  }, [collapsed]);

  if (isMobile) return null;

  const handleMouseEnter = (item) => {
    setHoveredItem(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem(null);
  };

  return (
    <div className={` ${isCollapsed ? "collapsed" : ""}`}  id="sidebar-admin">
      <div
        className={`d-flex ${
          isCollapsed
            ? "justify-content-center align-items-center"
            : "justify-content-between"
        } w-100 px-3 pt-4 pb-1`}
        id="sidebar-admin-header"
      >
        {!isCollapsed && <Image src={UpjLogoAdm} width={40} />}
        {!isCollapsed && <span className="title ms-2">Hello HRD UPJ</span>}
        <button
          className={`btn btn-outline-light ${isCollapsed ? "" : "ms-auto"}`}
          onClick={toggleSidebar}
        >
          <i className="bi bi-list burger-icon"></i>
          <i className="bi bi-x x-icon"></i>
        </button>
      </div>
      <hr className="text-white fw-bold w-100" />
      <div className="list-group d-flex gap-3">
        <NavLink
          to="dashboard"
          className={({ isActive }) =>
            isActive ? "list-group-item active" : "list-group-item"
          }
          onMouseEnter={() => handleMouseEnter("dashboard")}
          onMouseLeave={handleMouseLeave}
        >
          {({ isActive }) => (
            <>
              <i
                className={`bi ${
                  isActive || hoveredItem === "dashboard"
                    ? "bi-house-fill"
                    : "bi-house"
                } fs-5 me-2`}
              ></i>
              {!isCollapsed && <span className="fs-6">Dashboard</span>}
            </>
          )}
        </NavLink>
        <NavLink
          to="manageUser"
          className={({ isActive }) =>
            isActive ? "list-group-item active" : "list-group-item"
          }
          onMouseEnter={() => handleMouseEnter("manageUser")}
          onMouseLeave={handleMouseLeave}
        >
          {({ isActive }) => (
            <>
              <i
                className={`bi ${
                  isActive || hoveredItem === "manageUser"
                    ? "bi-person-fill"
                    : "bi-person"
                } fs-5 me-2`}
              ></i>
              {!isCollapsed && <span className="fs-6">Manage User</span>}
            </>
          )}
        </NavLink>
        <NavLink
          to="resultPsikotesUser"
          className={({ isActive }) =>
            isActive ? "list-group-item active" : "list-group-item"
          }
          onMouseEnter={() => handleMouseEnter("resultPsikotesUser")}
          onMouseLeave={handleMouseLeave}
        >
          {({ isActive }) => (
            <>
              <i
                className={`bi ${
                  isActive || hoveredItem === "resultPsikotesUser"
                    ? "bi-bar-chart-fill"
                    : "bi-bar-chart"
                } fs-5 me-2`}
              ></i>
              {!isCollapsed && <span className="fs-6">Psikotes Results</span>}
            </>
          )}
        </NavLink>
      </div>
    </div>
  );
};

export default Sidenav;